































import ClickOutside from 'vue-click-outside'
import Vue, { CreateElement, RenderContext, VNode } from 'vue'
export default Vue.extend({
  name: 'NavDropdown',
  components: {
    ChildrenAsList: {
      functional: true,
      render: (
        h: CreateElement,
        context: RenderContext
      ) => {
        const eventHandler = (vnode: VNode) => (event: MouseEvent | KeyboardEvent) => {
          const fn = context.listeners.itemClick as Function
          const keyCodes = [13, 32]
          if (
            event.type === 'click' ||
            keyCodes.includes((event as KeyboardEvent).keyCode)
          ) {
            fn(event, vnode)
          }
        }
        return h(
          'ul',
          {
            class: context.props.listClass,
            attrs: context.data.attrs
          },
          context.children.map(
            vnode => h(
              'li',
              {
                class: context.props.listItemClass,
                on: {
                  keydown: eventHandler(vnode),
                  click: eventHandler(vnode)
                }
              },
              [vnode]
            )
          )
        )
      }
    }
  },
  directives: {
    ClickOutside
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    close () {
      this.isOpen = false
    },
    keydown (event: KeyboardEvent) {
      if ([13, 32].includes(event.keyCode)) {
        this.toggle(true)
        event.preventDefault()
      }
    },
    toggle (keepFocus = false) {
      const target = this.$refs.activator as HTMLButtonElement
      if (target && !keepFocus) {
        target.blur()
      }
      this.isOpen = !this.isOpen
    }
  }
})
